<template>
<div class="date-select">
  <div class="date-select__input">
    <YearDropDownInput v-model="year" :startYear="startYear" :endYear="endYear" />
  </div>
  <div class="date-select__input">
    <MonthDropDownInput v-model="month" :startMonth="startMonth" />
  </div>
</div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import YearDropDownInput from "@kano/components/ProfitCalculator/Form/YearDropDownInput.vue";
import MonthDropDownInput from "@kano/components/ProfitCalculator/Form/MonthDropDownInput.vue";

const props = defineProps<{
  value: Date,
  startFrom: Date,
}>();

const emit = defineEmits<{
  (event: 'input', value: number): void,
}>();

const year = ref<number>(props.value.getFullYear());
const month = ref<number>(props.value.getMonth());
const startYear = ref<number>((new Date()).getFullYear());
const endYear = computed(() => startYear.value + 20);
const startMonth = ref<number>(null);
// XXX: Since we are interested in month, to battle timezone discrepancies, we always start from 2nd day of the month
const dateDayOffset = 2;

onMounted(() => {
  setYear();
  setMonths();
});

watch(() => props.startFrom, () => {
  setYear();
  setMonths();
  emit('input', new Date(year.value, month.value, dateDayOffset));
})
watch(year, () => {
  setMonths();
  emit('input', new Date(year.value, month.value,dateDayOffset));
});
watch(month, (newMonth) => {
  emit('input', new Date(year.value, newMonth, dateDayOffset));
});
const setYear = () => {
  startYear.value = props.startFrom.getFullYear();

  // Ensure the year is not before the allowed start year
  if (year.value < startYear.value) {
    year.value = startYear.value;
  }
}
const setMonths = () => {
  startMonth.value = null;

  // If we're in the same year as the start date, adjust the start month
  if (year.value === props.startFrom.getFullYear()) {
    startMonth.value = month.value = props.startFrom.getMonth() + 1;
  }

  if (startMonth.value > 11) {
    startMonth.value = null;
    year.value += 1;
  }
};

</script>

<style scoped lang="scss">
.date-select {
  display: flex;
  flex-direction: row;
  gap: 12px;

  &__input {
    flex-grow: 1;
  }
}
</style>